import {
  MondayStorageKeys,
  useGetFromMondayStorageQuery,
} from '@/hooks/api/useGetFromMondayStorageQuery';
import { useGetSessionToken } from '@/hooks/api/useGetSessionToken';
import NewOnboardingRoot from '@/pages/new-onboarding/NewOnboardingRoot';
import { isNewOnboardingFlow } from '@/utils/common';
import { lazy, Suspense } from 'react';

// @ts-expect-error JS file - Vite handles this dynamic import of a JS file into a TS file.
const GetStarted = lazy(() => import('@/pages/GetStarted'));

const RootRoute = () => {
  const { data: workflow } = useGetFromMondayStorageQuery(
    MondayStorageKeys.WORKFLOW_TYPE,
  );
  const { data: sessionToken } = useGetSessionToken();
  const isNewOnboarding = isNewOnboardingFlow(
    workflow,
    sessionToken?.dat?.account_id,
  );
  return isNewOnboarding ? (
    <NewOnboardingRoot />
  ) : (
    <Suspense fallback={<div />}>
      <GetStarted />
    </Suspense>
  );
};

export default RootRoute;
